export default __webpack_public_path__ + "static/media/Sage's Shoes of the Exalted Spirit.ed415129.jpg";